import { abaTemTrava, manterTravaDaAbaAtual } from './travaEntreAbas'

declare var window: any

// 491123 — extraído de useRecuperarCestaProdutosAnterior.ts para ser reaproveitado também pelo
// mecanismo equivalente de orcamentoEmAndamento (ver localizarOrcamentoEmAndamentoOrfaoDeOutraAba.ts,
// 482572). Reaproveita o MESMO canal ('mu_tabs_' + aba_id) que _Base.cshtml já usa para detectar aba
// duplicada: toda aba viva mantém um BroadcastChannel aberto nesse nome e responde 'present' a
// qualquer 'ping' (ver _Base.cshtml). Aqui só ouvimos a resposta — não registramos o comportamento
// de auto-eliminação daquele mecanismo, então é seguro fazer a pergunta por fora.
export const TIMEOUT_PROBE_ABA_VIVA_MS = 400

// 482572 — a aba atual passa a segurar um lock com o próprio abaId assim que este módulo carrega,
// para que as OUTRAS abas consigam detectá-la por `navigator.locks.query()` (ver travaEntreAbas.ts).
// Idempotente: chamadas repetidas não pedem o lock de novo.
export function registrarAbaAtualComoViva(abaId: string | null | undefined) {
    manterTravaDaAbaAtual(abaId)
}

function abaRespondeuAoPing(abaId: string): Promise<boolean> {
    return new Promise((resolve) => {
        if (!window.BroadcastChannel) {
            // Sem suporte a BroadcastChannel não há como confirmar — assume viva (mais seguro:
            // evita reivindicar um dado que ainda pode estar em uso em outra aba).
            resolve(true)
            return
        }

        const canal = new window.BroadcastChannel('mu_tabs_' + abaId)
        let respondido = false

        const finalizar = (resultado: boolean) => {
            if (respondido) return
            respondido = true
            clearTimeout(timeoutId)
            canal.close()
            resolve(resultado)
        }

        canal.onmessage = (evento: MessageEvent) => {
            if (evento.data === 'present') finalizar(true)
        }

        const timeoutId = setTimeout(() => finalizar(false), TIMEOUT_PROBE_ABA_VIVA_MS)

        canal.postMessage('ping')
    })
}

// 482572 — a aba é considerada VIVA se segurar o próprio lock **OU** responder ao ping. Os dois
// sinais somam, nunca se substituem, e isso é deliberado:
//
// - O LOCK é conclusivo e instantâneo (o navegador o libera sozinho quando a aba morre), e resolve o
//   falso-negativo do ping: uma aba viva mas em SEGUNDO PLANO (o Chrome faz throttling agressivo de
//   timers) ou presa numa chamada Fenix lenta não responde dentro dos 400ms e hoje é declarada
//   MORTA — aí outra aba reivindica e APAGA o snapshot de uma sessão que está em uso.
// - O PING continua necessário como rede de segurança: uma aba aberta ANTES deste deploy (ou que
//   ainda não carregou travaEntreAbas.ts) não segura lock nenhum, e sem o ping seria dada como morta.
//   Também cobre navegador sem Web Locks.
//
// Consulta o lock PRIMEIRO porque é barato e conclusivo: quando ele confirma que a aba está viva,
// nem paga os 400ms do ping.
export async function abaEstaViva(abaId: string): Promise<boolean> {
    if (await abaTemTrava(abaId)) return true

    return abaRespondeuAoPing(abaId)
}
